{
	"common": {
		"save": "Guardar",
		"skip": "Omitir",
		"back": "Atrás",
		"cancel": "Cancelar",
		"create-new": "Crear nuevo",
		"and-others_one": "y {{count}} más",
		"and-others_other": "y {{count}} más"
	},
	"settings": "Ajustes",
	"my-organisations": "Mis organizaciones",
	"my-role": "Mi papel:",
	"organisation-not-found": "Organización no encontrada",
	"tab-label-caregivers": "Cuidadores",
	"tab-label-care-recipients": "Destinatarios de cuidados",
	"tab-label-archived": "Archivado",
	"tab-label-temporary-access": "Acceso temporal",
	"toasts": {
		"success": {
			"role-updated": "Rol actualizado",
			"member-archived": "Usuario archivado",
			"caregivers-assigned": "Se han asignado cuidadores",
			"care-recipient-created": "Se ha creado el destinatario de la atención",
			"employee-created": "El empleado ha sido creado.",
			"profile-saved": "El perfil ha sido guardado.",
			"reset-password-mail-sent": "Enlace para restablecer contraseña enviado por correo electrónico",
			"team-created": "El equipo ha sido creado.",
			"teams-assigned": "Se han asignado equipos",
			"members-added-to-team": "Los miembros han sido agregados al equipo.",
			"member-removed-from-team": "El miembro ha sido eliminado del equipo.",
			"team-updated": "El equipo ha sido actualizado.",
			"invitation-accept-title": "Aceptado",
			"invitation-accept-content": "Aceptó con éxito la solicitud de conexión.",
			"invitation-reject-title": "Rechazado",
			"invitation-reject-content": "Has rechazado la solicitud de conexión.",
			"organization-updated": "La organización ha sido actualizada.",
			"temporary-access-invite-sent": "Se ha enviado una invitación de acceso temporal.",
			"temporary-access-revoked": "El acceso temporal ha sido revocado",
			"member-restored": "Miembro restaurado",
			"family-caregiver-disconnected": "El cuidador familiar ha sido desconectado"
		},
		"error": {
			"something-wrong": "Algo salió mal",
			"no-care-recipients-selected": "No se seleccionaron beneficiarios de atención"
		}
	},
	"table": {
		"header": {
			"username": "Nombre de usuario",
			"role": "Role",
			"email": "Correo electrónico",
			"name": "Nombre",
			"requester": "Solicitante",
			"care-recipient": "Receptor de cuidados",
			"access-end-date": "Fecha de finalización del acceso"
		},
		"actions": {
			"edit": "Editar",
			"archive": "Archivo",
			"unarchive": "Desarchivar",
			"assign-caregiver": "Asignar cuidador",
			"reset-password": "Restablecer la contraseña",
			"assign-to-teams": "Asignar a equipos",
			"remove-from-team": "Quitar del equipo",
			"invite-family-member": "invitar a un familiar",
			"view-profile": "Ver perfil",
			"accept": "Aceptar",
			"reject": "Rechazar",
			"temporary-access": "Acceso temporal",
			"revoke-access": "Revocar acceso",
			"deny-pletly-access": "Denegar acceso total"
		}
	},
	"new-employee": "Nuevo empleado",
	"assign": "Asignar",
	"assign-caregivers-to": "Asignar cuidadores a {{name}}",
	"inputs": {
		"organization-name": "Nombre de la organización"
	},
	"create-account-for-employee": "Crear cuenta para empleado",
	"create-account-for-care-recipient": "Crear cuenta para el destinatario de la atención",
	"care-recipient-created-confirmation": {
		"title": "Has creado correctamente una cuenta para {{name}}",
		"subtitle": "¿Quiere proporcionar más detalles sobre su destinatario de cuidados para ayudar a otros cuidadores a comprender mejor sus necesidades?",
		"secondaryButton": "Asignar cuidadores",
		"ctaButton": "Añadir información"
	},
	"fill-care-recipient-information": {
		"title": "Agregar información sobre el destinatario de la atención"
	},
	"fill-information-confirmation": {
		"ctaButton": "Asignar cuidadores",
		"subtitle": "Puede asignar cuidadores a {{name}}",
		"title": "¡Gracias!\n¡La información adicional siempre es útil!"
	},
	"teams": {
		"new-team": "Nuevo equipo",
		"form": {
			"label-name": "Nombre del equipo",
			"label-posts-screening": "Selección de publicaciones",
			"post-screening-disabled-info": "Se requiere al menos un administrador de equipo para cambiar esta configuración"
		},
		"teams": "Equipos",
		"team-not-found": "Equipo no encontrado",
		"no-teams-yet": "Aún no se han creado equipos.",
		"edit-team": "Editar equipo",
		"other-teams": "Otros equipos",
		"no-other-teams-created": "No se han creado otros equipos.",
		"new-sub-team": "Nuevo submarcado",
		"delete": {
			"are-you-sure-you-want-to-delete-the-name-team": "¿Estás seguro de que quieres eliminar el equipo {{ name }}?",
			"team-deleted": "Equipo eliminado",
			"this-will-also-remove-its-sub-teams-if-any": "Esto también eliminará sus equipos anidados.",
			"delete-team": "Eliminar equipo",
			"if-you-want-also-to-disconnect-caregivers-or-care-recipients-inside-team-please-do-so-first": "Si también desea desconectar a los cuidadores o los destinatarios del cuidado del equipo, hágalo primero.",
			"label-description": "Esta acción eliminará el equipo y no se puede deshacer."
		},
		"help-content": "Los equipos en Pletly le permiten administrar el acceso de los cuidadores más fácilmente. \nCuando agrega un cuidador a un equipo, automáticamente obtiene acceso a todos los destinatarios de la atención en ese equipo. \nAgregue un destinatario de atención al equipo y todos los cuidadores que lo integran se conectarán. \nElimine a alguien del equipo y la conexión también se eliminará.\n \nTambién puedes crear subequipos. \nLos cuidadores del equipo principal seguirán teniendo acceso a los destinatarios de la atención en sus subequipos, incluso si no están agregados directamente allí."
	},
	"assign-to-teams": "Asignar a equipos",
	"add-caregivers-to-team": "Agregar cuidadores al equipo",
	"add-care-recipients-to-team": "Agregar destinatarios de atención al equipo",
	"no-members-to-add": "No hay miembros para agregar",
	"confirmations": {
		"remove-from-team": {
			"title": "¿Quitar a {{name}} del equipo?",
			"content-caregiver": "Eliminar a un cuidador de un equipo lo desconectará de todos los destinatarios de la atención que pertenecen a ese equipo.",
			"content-care-recipient": "Eliminar a un destinatario de atención de un equipo lo desconectará de todos los cuidadores que pertenecen a ese equipo."
		},
		"accept-invitation": {
			"title": "¿Aceptar solicitud de conexión?",
			"content": "¿Está seguro de que desea aceptar la solicitud de {{requesterName}} para convertirse en el cuidador de {{careRecipientName}}?"
		},
		"reject-invitation": {
			"title": "¿Rechazar solicitud de conexión?",
			"content": "¿Está seguro de que desea rechazar la solicitud de {{requesterName}} para convertirse en el cuidador de {{careRecipientName}}?"
		},
		"revoke-temporary-access": {
			"title": "¿Revocar el acceso temporal?",
			"content": "¿Está seguro de que desea revocar el acceso temporal de {{caregiverEmail}} al perfil de {{careRecipientName}}?"
		},
		"archive-organisation-member": {
			"title": "Usuario de archivo",
			"content": "¿Estás seguro de que deseas archivar {{name}}?"
		},
		"block-organisation-member-login": {
			"title": "No permitir que el usuario use Pletly",
			"content": "El acceso se puede activar más tarde estableciendo una nueva contraseña. \n\n \n¿Está seguro de que desea bloquear el inicio de sesión de {{name}}?"
		},
		"unarchive-organisation-member": {
			"content": "¿Estás seguro de que quieres restaurar la cuenta de {{name}}?",
			"title": "Restaurar usuario"
		}
	},
	"tab-label-familycaregivers": "Cuidadores familiares",
	"terms-of-use": {
		"title": "Condiciones de uso",
		"manage-terms-of-use": "Administrar términos de uso",
		"new-version": "Nueva versión",
		"table": {
			"updated-at": "Actualizado en",
			"members-accepted": "Miembros aceptados",
			"text": "Texto"
		},
		"accepted": "Aceptado",
		"terms-of-use-accepted": "Términos de uso aceptados",
		"i-agree-to-the-terms-of-use-as-outlined-by": "Acepto los Términos de uso descritos por",
		"members-who-accepted": "Miembros que aceptaron",
		"new-terms-of-use": "Nuevas condiciones de uso",
		"new-terms-of-use-field-placeholder": "Condiciones de uso",
		"terms-of-use-created": "Términos de uso creados",
		"accept": "Aceptar"
	},
	"connection-requests": {
		"title": "Solicitudes de conexión",
		"view-all": "Ver todas las solicitudes"
	},
	"telephone": "Teléfono",
	"import-care-recipient": "Destinatario de atención de importación",
	"enter-the-care-recipients-unique-username-to-send-an-import-request-to-the-account-owner": "Ingrese el nombre de usuario único del destinatario de la atención para enviar una solicitud de importación al propietario de la cuenta.",
	"request-sent": "Solicitud enviada",
	"request-has-been-sent-to-the-care-receiver-guardian": "La solicitud ha sido enviada al tutor del beneficiario del cuidado.",
	"add-new": "Agregar nuevo",
	"create-new-care-recipient": "Crear nuevo destinatario de cuidados",
	"new-post": "Nueva publicación",
	"edit-organization": "Editar organización",
	"temporary-access": {
		"title": "Acceso temporal",
		"send-invite": "Enviar invitación",
		"label-access-duration": "Duración del acceso",
		"label-custom-duration": "Duración",
		"placeholder-select-care-recipients": "Seleccione los destinatarios de la atención",
		"label-select-care-recipients": "Destinatarios de atención seleccionados",
		"new-button": "Nuevo acceso temporal"
	},
	"roles": {
		"manager": "Administrador del sistema",
		"member": "Cuidador",
		"care-recipient": "Destinatario de la atención",
		"team-admin": "Administrador de equipo"
	},
	"allow-care-recipient-to-use-pletly": "Permitir que el destinatario de la atención utilice Pletly",
	"family-caregiver-connections-modal": {
		"title": "Conexiones de cuidadores familiares",
		"button-disconnect": "Desconectar",
		"confirm-disconnect": {
			"title": "Desconectar al cuidador familiar",
			"content": "¿Está seguro de que desea desconectar {{caregiverName}} y {{careRecipientName}}?"
		},
		"connections-list-empty": "La lista de conexiones está vacía."
	},
	"request-ownership": "Solicitar propiedad",
	"no-email": "Sin correo electrónico",
	"initial-password-for-first-login": "Contraseña inicial para el primer inicio de sesión"
}
